import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TimeInsideLayout from "./components/TimeInsideLayout";
import ScrollToTop from "./components/ScrollToTop";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import HomePage from "./pages/HomePage";
import AuthPage from "./pages/AuthPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AreaPersonalePage from "./pages/AreaPersonalePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import TerminiPage from "./pages/TerminiPage";
import ProdottiPage from "./pages/ProdottiPage";
import RisorsePage from "./pages/RisorsePage";
import LibriPage from "./pages/LibriPage";
import GuidePage from "./pages/GuidePage";
import ManualiPage from "./pages/ManualiPage";
import DossierPage from "./pages/DossierPage";
import ProductPlaceholderPage from "./pages/ProductPlaceholderPage";
import TimeIlLibroDelTempoPage from "./pages/TimeIlLibroDelTempoPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderConfirmedPage from "./pages/OrderConfirmedPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import { CartProvider } from "./context/CartContext";
import MonthlyRolloverProvider from "./components/MonthlyRolloverProvider";
import ServiziPage from "./pages/ServiziPage";
import AgentiAiPage from "./pages/AgentiAiPage";
import AgentPlaceholderPage from "./pages/AgentPlaceholderPage";
import ConsulenzePage from "./pages/ConsulenzePage";
import SessioniPage from "./pages/SessioniPage";
import TimerLapsePage from "./pages/TimerLapsePage";
import PercorsiPage from "./pages/PercorsiPage";
import TimeImmersionPage from "./pages/TimeImmersionPage";
import TrasfoproductPage from "./pages/TrasfoproductPage";
import InnovazionePage from "./pages/InnovazionePage";
import TimeWatchRoute from "./pages/TimeWatchRoute";
import TimeWatchHubPage from "./pages/TimeWatchHubPage";
import TimeWatchUtilityPage from "./pages/TimeWatchUtilityPage";
import TimeWatchOrologioPage from "./pages/TimeWatchOrologioPage";
import TimeWatchTimerPage from "./pages/TimeWatchTimerPage";
import TimeWatchPromemoriaPage from "./pages/TimeWatchPromemoriaPage";
import TimeWatchCronometroPage from "./pages/TimeWatchCronometroPage";
import TimeWatchSvegliaPage from "./pages/TimeWatchSvegliaPage";
import TimeWatchImprontaPage from "./pages/TimeWatchImprontaPage";
import TimeWatchIstantiPage from "./pages/TimeWatchIstantiPage";
import { makePlaceholder, PLACEHOLDERS } from "./pages/placeholders";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <MonthlyRolloverProvider />
          <CartProvider>
          <ScrollToTop />
          <Routes>
            {/* TIME Watch PMV is fullscreen and kept OUTSIDE the shell */}
            <Route path="/innovazione/time-watch/pmv" element={<TimeWatchRoute />} />

            {/* Everything else lives inside the TIME Inside shell */}
            <Route element={<TimeInsideLayout />}>
              <Route index element={<HomePage />} />
              <Route path="auth" element={<AuthPage />} />
              <Route path="auth/verifica-email" element={<VerifyEmailPage />} />
              <Route path="auth/password-dimenticata" element={<ForgotPasswordPage />} />
              <Route path="auth/reset-password" element={<ResetPasswordPage />} />
              <Route
                path="area-personale"
                element={
                  <ProtectedRoute>
                    <AreaPersonalePage />
                  </ProtectedRoute>
                }
              />

            <Route path="prodotti" element={<ProdottiPage />} />
            <Route path="prodotti/libri" element={<LibriPage />} />
            <Route
              path="prodotti/libri/time-il-libro-del-tempo"
              element={<TimeIlLibroDelTempoPage />}
            />
            <Route
              path="prodotti/libri/:slug"
              element={<ProductPlaceholderPage />}
            />
            <Route path="prodotti/risorse" element={<RisorsePage />} />
            <Route path="prodotti/risorse/guide" element={<GuidePage />} />
            <Route
              path="prodotti/risorse/guide/:slug"
              element={<ProductPlaceholderPage />}
            />
            <Route path="prodotti/risorse/manuali" element={<ManualiPage />} />
            <Route
              path="prodotti/risorse/manuali/:slug"
              element={<ProductPlaceholderPage />}
            />
            <Route path="prodotti/risorse/dossier" element={<DossierPage />} />
            <Route
              path="prodotti/risorse/dossier/:slug"
              element={<ProductPlaceholderPage />}
            />
            <Route path="servizi" element={<ServiziPage />} />
            <Route path="servizi/agenti-ai" element={<AgentiAiPage />} />
            <Route
              path="servizi/agenti-ai/:slug"
              element={<AgentPlaceholderPage />}
            />
            <Route path="servizi/consulenze" element={<ConsulenzePage />} />
            <Route
              path="servizi/consulenze/:slug"
              element={<ProductPlaceholderPage />}
            />
            <Route path="servizi/sessioni" element={<SessioniPage />} />
            <Route
              path="servizi/sessioni/:slug"
              element={<ProductPlaceholderPage />}
            />
            <Route path="timer-lapse" element={<TimerLapsePage />} />
            <Route path="percorsi" element={<PercorsiPage />} />
            <Route
              path="percorsi/time-immersion"
              element={<TimeImmersionPage />}
            />
            <Route
              path="percorsi/time-immersion/:slug"
              element={<ProductPlaceholderPage />}
            />
            <Route
              path="percorsi/trasfoproduct"
              element={<TrasfoproductPage />}
            />
            <Route
              path="percorsi/trasfoproduct/:slug"
              element={<ProductPlaceholderPage />}
            />
            <Route path="innovazione" element={<InnovazionePage />} />

            {/* E-commerce · Carrello + Checkout */}
            <Route path="carrello" element={<CartPage />} />
            <Route path="checkout" element={<CheckoutPage />} />
            <Route path="checkout/conferma" element={<OrderConfirmedPage />} />
            <Route path="payment/success" element={<PaymentSuccessPage />} />
            <Route path="payment/cancel" element={<PaymentCancelPage />} />

            {/* Documenti legali */}
            <Route path="privacy" element={<PrivacyPolicyPage />} />
            <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="cookie-policy" element={<CookiePolicyPage />} />
            <Route path="termini" element={<TerminiPage />} />
            <Route
              path="innovazione/time-watch"
              element={<TimeWatchHubPage />}
            />
            <Route
              path="innovazione/time-watch/utility"
              element={<TimeWatchUtilityPage />}
            />
            <Route
              path="innovazione/time-watch/utility/timer"
              element={<TimeWatchTimerPage />}
            />
            <Route
              path="innovazione/time-watch/utility/promemoria"
              element={<TimeWatchPromemoriaPage />}
            />
            <Route
              path="innovazione/time-watch/utility/cronometro"
              element={<TimeWatchCronometroPage />}
            />
            <Route
              path="innovazione/time-watch/utility/sveglia"
              element={<TimeWatchSvegliaPage />}
            />
            <Route
              path="innovazione/time-watch/utility/impronta"
              element={<TimeWatchImprontaPage />}
            />
            <Route
              path="innovazione/time-watch/utility/istanti"
              element={<TimeWatchIstantiPage />}
            />
            <Route
              path="innovazione/time-watch/orologio"
              element={<TimeWatchOrologioPage />}
            />

            {Object.keys(PLACEHOLDERS).map((key) => {
              const Component = makePlaceholder(key);
              return (
                <Route key={key} path={key} element={<Component />} />
              );
            })}

            <Route path="*" element={<HomePage />} />
          </Route>
        </Routes>
        </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
